import { isAfter, isBefore, isValid, parseISO } from 'date-fns';

import type { TagSheetAd, TagSheetLineItem } from '../types';

export const parseDateTime = (dateTimeStr: string | undefined | null): Date | null => {
  if (!dateTimeStr) return null;

  const parsed = parseISO(dateTimeStr);

  return isValid(parsed) ? parsed : null;
};

export const validateDates = (ad: TagSheetAd, lineItem: TagSheetLineItem): string | null => {
  const adStart = parseDateTime(ad.startDate);
  const adEnd = parseDateTime(ad.endDate);

  if (!adStart && adEnd) {
    return `Ad "${ad.adName}" has an end date but no start date.`;
  }

  if (!lineItem.startDate && !lineItem.endDate) return null;

  const liStart = parseDateTime(lineItem.startDate);
  const liEnd = parseDateTime(lineItem.endDate);

  if (liStart && adStart && isBefore(adStart, liStart)) {
    return `Ad "${ad.adName}" starts on ${ad.startDate}, which is before the line item start date.`;
  }

  if (liEnd && adEnd && isAfter(adEnd, liEnd)) {
    return `Ad "${ad.adName}" ends on ${ad.endDate}, which is after the line item end date.`;
  }

  return null;
};
